import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTransactionExportIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12 7V16",
			stroke: "#4D5055",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.2427 12L12 16.2426L7.75739 12",
			stroke: "#4D5055",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M15.5 4.25203C18.4485 5.58602 20.5 8.55358 20.5 12.0003C20.5 16.6947 16.6944 20.5003 12 20.5003C7.30558 20.5003 3.5 16.6947 3.5 12.0003C3.5 8.55356 5.55149 5.58599 8.50002 4.25201L8.50001 2.62988C4.70334 4.04862 2 7.70875 2 12.0003C2 17.5231 6.47715 22.0003 12 22.0003C17.5228 22.0003 22 17.5231 22 12.0003C22 7.70876 19.2967 4.04863 15.5 2.62989L15.5 4.25203Z",
			fill: "#4D5055"
		})
	]
});
export default SvgTransactionExportIcon;
